import React, { useEffect, useState } from "react";
import Flex from "../Flex";
import { Button, Typography } from "antd";
import {
  checkIfImpersonating,
  endImpersonation,
} from "../../store/actions/authActionCreators";
import { saveAuthUserInfo } from "./header";
import { ILoginData } from "../../interfaces/auth.interface";
import {
  InfoCircleOutlined,
  MailOutlined,
  UserOutlined,
} from "@ant-design/icons";

export default function ImpersonationAlertPanel({
  userDetails,
}: {
  userDetails: ILoginData | null;
}) {
  const [userIsImpersonating, setUserIsImpersonating] =
    useState<boolean>(false);
  const [endImpersonationLoading, setEndImpersonationLoading] =
    useState<boolean>(false);

  useEffect(() => {
    _checkIfImpersonating();
  }, []);

  async function _checkIfImpersonating() {
    const [impersonationRes, error] = await checkIfImpersonating();
    if (!!impersonationRes) {
      setUserIsImpersonating(impersonationRes.data);
    }
  }

  async function handleEndImpersonation() {
    setEndImpersonationLoading(true);
    await endImpersonation().then(([impersonationRes, error]) => {
      setTimeout(() => {
        saveAuthUserInfo(impersonationRes);
        window.location.reload();
      }, 0);
    });
    setEndImpersonationLoading(false);
  }

  if (!userIsImpersonating) {
    return null;
  }

  return (
    <Flex align="center" gap="1rem" style={{ marginLeft: "2rem" }}>
      <Typography.Title style={{ margin: 0 }} level={4}>
        You are logged in as
      </Typography.Title>
      <Flex
        vertical
        style={{
          border: "1px dashed #ccd9f1",
          backgroundColor: "rgba(204, 217, 241, 0.15)",
          padding: "0.1rem 0.5rem",
          borderRadius: "0.5rem",
        }}
      >
        <Flex gap="0.25rem">
          <UserOutlined style={{ fontSize: "0.8rem", margin: "-10px 0" }} />
          <Typography.Text style={{ margin: 0 }}>
            {userDetails?.data.userName}
          </Typography.Text>
        </Flex>
        <Flex gap="0.25rem">
          <MailOutlined style={{ fontSize: "0.8rem" }} />
          <Typography.Text
            color="primary"
            style={{ margin: 0, fontWeight: 400 }}
          >
            {userDetails?.data.email}
          </Typography.Text>
        </Flex>
      </Flex>
      <Button
        loading={endImpersonationLoading}
        type="primary"
        danger
        onClick={handleEndImpersonation}
      >
        Switch back to your account
      </Button>
    </Flex>
  );
}
